
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[uid]/[verticalid]/[clusterid]/[productid]/[thankyouid]",
      function () {
        return require("private-next-pages/[uid]/[verticalid]/[clusterid]/[productid]/[thankyouid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[uid]/[verticalid]/[clusterid]/[productid]/[thankyouid]"])
      });
    }
  